import { render, staticRenderFns } from "./index.vue?vue&type=template&id=06c0ca2b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c0ca2b')) {
      api.createRecord('06c0ca2b', component.options)
    } else {
      api.reload('06c0ca2b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=06c0ca2b", function () {
      api.rerender('06c0ca2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Customers/Endusers/index.vue"
export default component.exports